import { Logger } from "../../02_utils/logger";
import { Utils } from "../../02_utils/utils";

export class Select {
  constructor(private $log: Logger, private $utils: Utils) {
    const selects: NodeListOf<HTMLSelectElement> = document.querySelectorAll('.js-select');

    selects?.forEach(select => {
      this.initSelect(select);
    });

    this.initClickOutside(selects);
  }

  private initSelect(select: HTMLSelectElement) {
    const button: HTMLElement = select.querySelector('.js-select-button');
    const options: NodeListOf<HTMLElement> = select.querySelectorAll('.js-select-option');
    const output = select.querySelector('.js-select-output');

    button?.addEventListener('click', () => {
      if (select.classList.contains('active')) {
        this.$utils.addOrRemoveClases('remove', 'active', select);
      } else {
        this.$utils.addOrRemoveClases('add', 'active', select);
      }
    }, {passive: true});

    const selectElement = select.querySelector('select');

    if (selectElement.value) {
      output.innerHTML = selectElement.value;
    }

    options?.forEach(option => {
      option.addEventListener('click', () => {
        options?.forEach(option => {
          option.dataset.selected = 'false';
        });

        output.innerHTML = option.innerHTML;
        button.dataset.value = option.dataset.value
        option.dataset.selected = 'true';
        this.$utils.addOrRemoveClases('remove', 'active', select);

        if (selectElement) {
          selectElement.value = option.dataset.value;
          selectElement.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  private initClickOutside(selects: NodeListOf<HTMLElement>) {
    document.addEventListener('click', (event: Event) => {
      selects?.forEach(select => {
        if (!select.contains(event.target as Node)) {
          this.$utils.addOrRemoveClases('remove', 'active', select);
        }
      });
    }, {passive: true});
  }
}
